// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item-title[data-v-1cc57ce1] {\n  height: 50px;\n}\n", ""]);
// Exports
module.exports = exports;
